export default [
  {
    path: '/customer',
    name: 'customer',
    meta: {
      login: true
    }
  },
  { path: '/customer/FeedbackControl', name: 'FeedbackControl', component: resolve => require(['@/views/customer/FeedbackControl'], resolve) },
  { path: '/customer/ApplyReport', name: 'ApplyReport', component: resolve => require(['@/views/customer/ApplyReport'], resolve) },
  { path: '/customer/DownloadReport', name: 'DownloadReport', component: resolve => require(['@/views/customer/DownloadReport'], resolve) },
  { path: '/customer/LittleNote', name: 'LittleNote', component: resolve => require(['@/views/customer/LittleNote'], resolve) },
  { path: '/customer/VideoInterpretation', name: 'VideoInterpretation', component: resolve => require(['@/views/customer/VideoInterpretation'], resolve) },
  { path: '/customer/ActivityConfig', name: 'ActivityConfig', component: resolve => require(['@/views/customer/ActivityConfig'], resolve) },
  { path: '/customer/CetiInterpretation', name: 'CetiInterpretation', component: resolve => require(['@/views/customer/CetiInterpretation'], resolve) },
  { path: '/customer/invoiceControl', name: 'invoiceControl', component: resolve => require(['@/views/customer/invoiceControl'], resolve) },
  { path: '/customer/PMManagement', name: 'PMManagement', component: resolve => require(['@/views/customer/PMManagement'], resolve) },
  { path: '/customer/flowtoManagement', name: 'flowtoManagement', component: resolve => require(['@/views/customer/flowtoManagement'], resolve) },
  { path: '/customer/dataBoardManagement', name: 'dataBoardManagement', component: resolve => require(['@/views/customer/dataBoardManagement'], resolve) },
  { path: '/customer/dataBoardLog', name: 'dataBoardLog', component: resolve => require(['@/views/customer/dataBoardLog'], resolve) },
  { path: '/customer/record', name: 'record', component: resolve => require(['@/views/customer/record'], resolve) },
  { path: '/customer/versionNotice', name: 'versionNotice', component: resolve => require(['@/views/customer/versionNotice'], resolve) },
  {
    path: '/customer/userTrialApplication',
    name: 'UserTrialApplication',
    component: resolve => require(['@/views/customer/UserTrialApplication'], resolve)
  },
  {
    path: '/customer/WorkstationIntroConfig',
    name: 'ProductPresentationSetting',
    component: resolve => require(['@/views/customer/ProductPresentationSetting'], resolve)
  },
  { path: '/customer/bannerConfig', name: 'bannerConfig', component: resolve => require(['@/views/customer/bannerConfig'], resolve) },
  { path: '/customer/portNoticeConfig', name: 'portNoticeConfig', component: resolve => require(['@/views/customer/portNoticeConfig'], resolve) },
  { path: '/customer/userList', name: 'userList', component: resolve => require(['@/views/customer/userList'], resolve) },
  { path: '/customer/userListChannel', name: 'userListChannel', component: resolve => require(['@/views/customer/userListChannel'], resolve) },
  { path: '/customer/potentialUserList', name: 'potentialUserList', component: resolve => require(['@/views/customer/potentialUserList'], resolve) },
  {
    path: '/customer/companyUserApplyList',
    name: 'companyUserApplyList',
    component: resolve => require(['@/views/customer/companyUserApplyList'], resolve)
  },
  {
    path: '/customer/postEmail',
    name: 'postEmail',
    component: resolve => require(['@/views/customer/postEmail'], resolve)
  },
  {
    path: '/customer/userQueryStatistic',
    name: 'userQueryStatistic',
    component: resolve => require(['@/views/customer/userQueryStatistic'], resolve)
  },
  {
    path: '/customer/expendVesselManagement',
    name: 'expendVesselManagement',
    component: resolve => require(['@/views/customer/expendVesselManagement'], resolve)
  },
  {
    path: '/customer/firstScreenNotify',
    name: 'firstScreenNotify',
    component: resolve => require(['@/views/customer/firstScreenNotify'], resolve)
  },
  {
    path: '/customer/sanctionList',
    name: 'sanctionList',
    component: resolve => require(['@/views/customer/sanctionList'], resolve)
  },
  {
    path: '/customer/sentimentIndex',
    name: 'sentimentIndex',
    component: resolve => require(['@/views/customer/sentimentIndex'], resolve)
  },
  {
    path: '/customer/riskReportManagement',
    name: 'riskReportManagement',
    component: resolve => require(['@/views/customer/riskReportManagement'], resolve)
  }
]



// WEBPACK FOOTER //
// ./src/config/router/customer.js